export default class SiteMeterService {
  constructor(baseUri) {
    this.baseUri = baseUri
  }

  async create(siteMeter, options) {
    const response = await fetch(`${this.baseUri}/meterManagement/siteMeter`, {
      body: JSON.stringify(siteMeter),
      headers: {
        'Authorization': `Bearer ${options.accessToken}`,
        'Content-Type': 'application/json'
      },
      method: 'POST'
    })

    return await response.json()
  }

  async delete(id, options) {
    const response = await fetch(`${this.baseUri}/meterManagement/siteMeter/${id}`, {
      headers: {
        'Authorization': `Bearer ${options.accessToken}`
      },
      method: 'DELETE'
    })

    return response.ok
  }

  async find(id, options) {
    try {
      const response = await fetch(`${this.baseUri}/meterManagement/siteMeter/${id}`, {
        headers: {
          'Authorization': `Bearer ${options.accessToken}`
        }
      })

      return await response.json()
    } catch (e) {
      return null
    }
  }

  async getAll(options) {
    const response = await fetch(`${this.baseUri}/meterManagement/siteMeter`, {
      headers: {
        'Authorization': `Bearer ${options.accessToken}`
      }
    })

    return await response.json()
  }

  async update(id, siteMeter, options) {
    const response = await fetch(`${this.baseUri}/meterManagement/siteMeter/${id}`, {
      body: JSON.stringify(siteMeter),
      headers: {
        'Authorization': `Bearer ${options.accessToken}`,
        'Content-Type': 'application/json'
      },
      method: 'PUT'
    })

    return response.ok
  }
}